import {
  getOptimizedPoints,
  getDistanceMatrix,
  findOptimalRoute,
  findSortedByDistanceRoute
} from '../../services/routes.js'
import { getTSPWay } from '../../services/getTSPWay'
import { sortPointsByDistance } from '../../tools/points.js'
import { createRoutingList } from '../../services/bitrixcrm.js'
import { mapState, mapGetters, mapActions } from 'pinia'
import { useRoutingStore } from '../../store.js'
import './buttonspanel.css'

export const ButtonsPanel = {
  data () {
    return {
      submitWaiting: false,
      optimizeWaiting: true, //false
      currUserId: null,
      previousValue: null,
      isShortestRouteAvailable: true
    }
  },
  computed: {
    ...mapState(useRoutingStore, [
      'RLWaypoints',
      'RLName',
      'RLTime',
      'RLStartPoint',
      'RLRouteOptimized',
      'IsCycle',
      'RLRouteLineCoordinates',
      'RLDriver',
      'selectedPoints',
      'inputStartTimeStore',
      'inputTimeForPoint',
      'RLRouteDuration',
      'RLRouteLength',
      'fullDuration'
    ]),
    ...mapGetters(useRoutingStore, ['getRoutePoints', 'getTSPRoutePoints1'])
  },
  watch: {
    IsCycle (newVal) {
      if (newVal !== this.previousValue) {
        this.previousValue = newVal
      }
    }
  },

  methods: {
    ...mapActions(useRoutingStore, [
      'setWaypoints',
      'switchOptimizeState',
      'setRouteLength',
      'setRouteDuration',
      'setRLRouteLineCoordinates',
      'setSelectedPoints',
      'checkStoreData'
    ]),
    async optimizeRoute () {
      if (!this.RLRouteLineCoordinates) {
        alert('Проложите маршрут!')
        return
      }
      if (this.optimizeWaiting === true) {
        alert('Уже оптимизировано!')
        return
      }
      //this.optimizeWaiting = true;
      const points = this.selectedPoints.filter(item => item.ID !== this.RLStartPoint.ID)
      try {
        // Делаем копии объектов стейта чтоб избежать мутации данных
        let startPoint = this.RLStartPoint
          ? { ...this.RLStartPoint }
          : { ...this.selectedPoints[0] }
        let sortedPoints = await sortPointsByDistance(startPoint, [
          ...points.map(point => ({ ...point }))
        ])

        const batchSize = 3
        let optimizedPoints = []
        let requestCount = 0
        while (sortedPoints.length > 1) {
          // Продолжаем, пока остаются непосещенные точки
          const batch = sortedPoints.slice(0, batchSize) // Берем первые batchSize элементов

          // Находим ближайшую точку в текущем подмассиве
          const closestPoint = await this.findClosestPoint(startPoint, batch)
          requestCount += batch.length
          optimizedPoints.push(closestPoint)

          // Устанавливаем новую начальную точку и удаляем её из sortedPoints
          startPoint = closestPoint
          sortedPoints = sortedPoints.filter(point => point['ID'] !== closestPoint['ID']) // Удаляем выбранную точку
        }

        // Добавляем оставшуюся точку в конец оптимизированного маршрута, если нужно
        if (sortedPoints.length === 1) {
          optimizedPoints.push(sortedPoints[0])
        }
        const optimizedPointsIDs = optimizedPoints.map(item => item.ID)
        const missing = this.RLWaypoints.filter(p => !optimizedPointsIDs.includes(p.ID))

        this.setWaypoints([...optimizedPoints, ...missing])
        this.setSelectedPoints(optimizedPoints)
        this.createRouteLine()
        // Обновляем waypoints оптимизированными точками
        this.switchOptimizeState()
        this.optimizeWaiting = true
      } catch (e) {
        throw e
      } finally {
        this.optimizeWaiting = true
        //this.optimizeWaiting = false;
      }
    },

    async getTSPRoutePoints () {
      try {
        let points = []
        let duration = 0
        let length = 0
        let fullWay
        // fullWay = this.IsCycle
        //   ? [this.RLStartPoint, ...this.selectedPoints, this.RLStartPoint]
        //   : [this.RLStartPoint, ...this.selectedPoints]
        fullWay = [this.RLStartPoint, ...this.selectedPoints]
        const testData = await getTSPWay(fullWay)
        // const response = await getOptimizedPoints(fullWay);
        testData.route.legs.forEach(leg => {
          let legStep = []
          leg.steps.forEach(step => {
            length += step.length
            duration += step.duration
            legStep = legStep.concat(step.polyline.points.map(subArray => [...subArray].reverse()))
            // legStep = legStep.concat(step.polyline.points);
          })

          points.push(legStep)
        })

        length = (length / 1000).toFixed(2) // километры
        let hours = duration / 3600
        let minutes = Math.round((hours % 1) * 60)

        return {
          points,
          length: parseFloat(length),
          duration: {
            seconds: parseFloat(duration),
            timeString: `${Math.floor(hours)} ч. ${String(minutes).padStart(2, '0')} м.`
          },
          optimalRoute: testData.route.optimalRoute,
          bestResult: testData.route.bestResult
        }
      } catch (error) {
        console.error('Ошибка при загрузке точек маршрута:', error)
        return {
          points: [],
          length: null,
          duration: null
        }
      }
    },

    async submitHandler () {
      this.submitWaiting = true

      const params = {
        waypoints: this.selectedPoints,
        startPoint: this.RLStartPoint,
        comment: this.RLName,
        IsCycle: this.IsCycle,
        RLDriver: this.RLDriver?.ID,
        startDate: this.inputStartTimeStore,
        duration: this.fullDuration,
        RLRouteLength: this.RLRouteLength
      }

      this.$emit('route-data', params)

      try {
        const response = await createRoutingList(params)

        //this.beforeSubmitHandler("Маршрутный лист успешно создан!", response['answer']['result']['item']);
      } catch (e) {
        this.beforeSubmitHandler('Произошла ошибка при создании.')
        throw e
      } finally {
        this.submitWaiting = false
      }
    },
    async createRouteLine () {
      try {
        this.checkStoreData()
      } catch (err) {
        alert(err.message)
        return
      }

      const { points, length, duration } = await this.getRoutePoints

      if (points.length > 0) {
        this.setRLRouteLineCoordinates(points)
      } else {
        this.setRLRouteLineCoordinates(null)
      }
      this.setRouteLength(length)
      this.setRouteDuration(duration)

      this.optimizeWaiting = false
    },
    async createShortestRouteLine () {
      try {
        this.checkStoreData()
      } catch (err) {
        alert(err.message)
        return
      }

      if (!this.isShortestRouteAvailable) {
        return
      }

      this.isShortestRouteAvailable = false

      const { points, length, duration, optimalRoute, bestResult } = await this.getTSPRoutePoints()

      if (points.length > 0) {
        this.setRLRouteLineCoordinates(points)
      } else {
        this.setRLRouteLineCoordinates(null)
      }
      this.setRouteLength(length)
      this.setRouteDuration(duration)

      let optimizedPoints = []

      optimizedPoints = optimalRoute.slice(1, -1)
      const optimizedPointsIDs = optimizedPoints.map(item => item.ID)
      const missing = this.RLWaypoints.filter(p => !optimizedPointsIDs.includes(p.ID))

      this.setWaypoints([...optimizedPoints, ...missing])
      this.setSelectedPoints(optimizedPoints)
      this.createRouteLine()
      // Обновляем waypoints оптимизированными точками
      this.switchOptimizeState()

      this.optimizeWaiting = false

      this.isShortestRouteAvailable = true
    },
    beforeSubmitHandler (message, responseItem) {
      //BX.SidePanel.Instance.open(`/crm/type/133/details/${responseItem['id']}/`)
    },

    async findClosestPoint (origin, remainingDestinations) {
      const data = await getDistanceMatrix([origin], remainingDestinations)

      if (!data || !data.rows || !data.rows[0] || !data.rows[0].elements) {
        throw new Error('Ошибка при получении данных матрицы расстояний')
      }

      // Ищем минимальное расстояние
      let minDistanceIndex = 0
      let minDistance = data.rows[0].elements[0].distance.value

      for (let i = 1; i < data.rows[0].elements.length; i++) {
        const distance = data.rows[0].elements[i].distance.value
        if (distance < minDistance) {
          minDistance = distance
          minDistanceIndex = i
        }
      }
      return remainingDestinations[minDistanceIndex]
    }
  },

  async mounted () {
    //const response = await BX.rest.callMethod("im.user.get", {});
    //this.currUserId = response["answer"]["result"]["id"];
  },

  // language=Vue
  template: `
          <div class="ymap-buttonspanel_container">
            <button class="ui-btn ui-btn-success-light"
                    @click="createShortestRouteLine"
                    :disabled="!isShortestRouteAvailable"
                    style="height: 2rem;">
              Проложить кратчайший маршрут
            </button>
          <button class="ui-btn ui-btn-success-light"
                    @click="createRouteLine"
                    style="height: 2rem;">
              Проложить маршрут
            </button>
            <button
                class="ui-btn ui-btn-secondary"
                :class="{'ui-btn-wait': optimizeWaiting}"
                @click="optimizeRoute"
                style="height: 2rem;"
            >
              Оптимизировать
            </button>
            <button
                class="ui-btn ui-btn-success-light"
                style="height: 2rem;"
                :class="{'ui-btn-wait':submitWaiting}"
                @click="submitHandler"
            >
              Создать МЛ
            </button>
          </div>
        `
}

// <button
//     class="ui-btn ui-btn-secondary"
//     :class="{'ui-btn-wait': optimizeWaiting}"
//     @click="optimizeRoute"
//     style="height: 2rem;"
//     :disabled="RLRouteOptimized"
// >
//   Оптимизировать
// </button>
